export function configureLogFetchErrors(configureRaven, config) {
  configureRaven(`https://exceptions.hubspot.com/v2/js`, config.options);
}